import {
    Alert, Box, Button, Card, CardActions, CardContent,
    CircularProgress, FormControl, FormHelperText, Grid, TextField,
    Typography
} from '@mui/material';
import { useEffect, useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import toast from 'react-hot-toast';
import { useNavigate, useParams } from 'react-router-dom';
import { apiService } from '../../api/axiosClient';
import Page from '../../components/Page';
import { FileUploaderSingle } from '../../components/upload';
import DropzoneWrapper from '../../styles/react-dropzone';

const Catalog = () => {
    const params = useParams();
    const navigate = useNavigate();
    const [item, setItem] = useState('');
    const [loading, setLoading] = useState(false);
    const [icons, setIcons] = useState([]);
    const [files, setFiles] = useState([]);
    const {
        control,
        handleSubmit,
        formState: { errors },
        reset,
    } = useForm()

    useEffect(() => {
        const fetchData = async () => {
            const response = await apiService.get(`/catalog/${params.id}`)
            const payload = response.data;
            setItem(payload.data)
        }

        fetchData().catch(e => console.error(e));
    }, [params.id]);

    useEffect(() => {
        const defaultValues = {
            title: item?.title,
            showorder: item?.showorder
        }
        reset(defaultValues);
        setIcons(item.icon ? [item.icon] : []);
        setFiles(item.url ? [item.url] : []);
    }, [reset, item]);

    const goBack = () => {
        navigate(-1)
    }

    const onSubmit = async (data, e) => {
        setLoading(true)

        const [icon] = icons;
        const [file] = files;

        const formData = new FormData();
        formData.append('title', data.title);
        formData.append('showorder', data.showorder);
        formData.append('icon', icon);
        formData.append('file', file);

        await apiService.putFormData(`/catalog/${item.id}`, formData)
        .then(response => {
            toast.success('업데이트 되었습니다.')
            goBack()
        }).finally(() => {
            setLoading(false)
        });
    }

    return (
        <Page title="Catalog">
            <Card>
                <form onSubmit={handleSubmit(onSubmit)} id="catalogform">
                    <CardContent sx={{ pt: 8 }}>
                        <Box sx={{ mb: 9, textAlign: 'center' }}>
                            <Typography variant='h5' sx={{ mb: 3, lineHeight: '2rem' }}>
                                Catalog
                            </Typography>
                        </Box>

                        <Grid container spacing={6}>
                            <Grid item xs={12}>
                                <FormControl fullWidth>
                                <Controller
                                    name='title'
                                    control={control}
                                    rules={{ required: true }}
                                    defaultValue=""
                                    render={({ field: { value, onChange } }) => (
                                    <TextField
                                        value={value}
                                        label='제목'
                                        id='title'
                                        onChange={onChange}
                                        placeholder='제목을 입력해주세요'
                                        error={Boolean(errors.title)}
                                        aria-describedby='validation-async-title'
                                        variant="standard"
                                    />
                                    )}
                                />
                                {errors.title && (
                                    <FormHelperText sx={{ color: 'error.main' }} id='validation-async-title'>
                                    필수
                                    </FormHelperText>
                                )}
                                </FormControl>
                            </Grid>                            

                            <Grid item xs={12}>
                                <FormControl fullWidth>
                                <Controller
                                    name='showorder'
                                    control={control}
                                    rules={{ required: true }}
                                    defaultValue=""
                                    render={({ field: { value, onChange } }) => (
                                    <TextField
                                        value={value}
                                        label='순서'
                                        id='showorder'
                                        onChange={onChange}
                                        placeholder='순서를 입력해주세요'
                                        error={Boolean(errors.showorder)}
                                        aria-describedby='validation-async-showorder'
                                        variant="standard"
                                    />
                                    )}
                                />
                                {errors.showorder && (
                                    <FormHelperText sx={{ color: 'error.main' }} id='validation-async-showorder'>
                                    필수
                                    </FormHelperText>
                                )}
                                </FormControl>
                            </Grid>

                            <Grid item xs={12} md={6}>
                                <Alert severity='info' sx={{mb:2}}> 카탈로그 표지 이미지를 업로드하세요 </Alert>                                
                                <DropzoneWrapper>
                                    <FileUploaderSingle files={icons} setFiles={setIcons} update={true} />
                                </DropzoneWrapper>
                            </Grid>
                            
                            <Grid item xs={12} md={6}>
                                <Alert severity='warning' sx={{mt:2, mb:2}}> 카탈로그 pdf 파일를 업로드하세요 </Alert>
                                <DropzoneWrapper>
                                    <FileUploaderSingle files={files} setFiles={setFiles} update={true}/>
                                </DropzoneWrapper>
                            </Grid>

                        </Grid>
                    </CardContent>
                </form>

                <CardActions className='card-action'>
                    <Button type="submit" form="catalogform" variant='contained'>
                        {loading ? (
                            <CircularProgress
                                sx={{
                                    color: 'common.white',
                                    width: '20px !important',
                                    height: '20px !important',
                                    mr: theme => theme.spacing(2)
                                }}
                            />
                        ) : null}
                        수정
                    </Button>
                    <Button variant='outlined' color='secondary' onClick={goBack}>
                        취소
                    </Button>
                </CardActions>
            </Card>
        </Page>
    )
}

export default Catalog